import React from "react";
import { TenantForm } from "../../components/Forms/TenantForm";
import { useGetBoMeQuery } from "../../store/services/api";

export const NewTenant = () => {
  // MT-011 — Crear tenant es exclusivo de SUPER_ADMIN.
  const { data: me, isLoading: meLoading } = useGetBoMeQuery();

  if (meLoading) return <div className="p-4">Cargando…</div>;
  if (me?.role !== "SUPER_ADMIN") {
    return (
      <div className="p-4">
        <div className="p-3 border-round surface-200 text-700">
          Acceso restringido: solo un SUPER_ADMIN puede crear tenants.
        </div>
      </div>
    );
  }

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card">
          <div className="flex align-items-center justify-content-between mb-4">
            <h3 className="text-2xl font-semibold text-900 m-0">
              <i className="pi pi-plus-circle mr-2 text-primary"></i>
              Crear Nuevo Tenant
            </h3>
          </div>
          <TenantForm isEdit={false} />
        </div>
      </div>
    </div>
  );
};
